import { ButtonSt } from "./styles";

const Button = ({ children }) => {
  return <ButtonSt>{children}</ButtonSt>;
};

export default Button;
